import cn from 'classnames';
import { ReactElement } from 'react';
import styles from './Tag.module.scss';
import { Icon, IconProps } from '../Icon/Icon';

interface TagI {
  text: string;
  className?: string;
  icon?: IconProps['type'];
  iconPosition?: 'left' | 'right';
  iconSize?: 'small' | 'medium' | 'large';
  iconColor?: 'primary' | 'secondary' | 'tertiary';
  iconClassName?: string;
  enableHover?: boolean;
  hoverContent?: ReactElement | ReactElement[]; // Optional prop for info icon text
}

export const Tag = ({
  text,
  className,
  icon,
  iconPosition = 'left',
  iconSize = 'small',
  iconColor = 'primary',
  iconClassName,
  enableHover = false,
  hoverContent = <div />,
}: TagI) => {
  const iconClasses = cn(styles.icon, {
    [styles[`icon-${iconSize}`]]: iconSize,
    [styles[`icon-${iconColor}`]]: iconColor,
    [iconClassName]: iconClassName,
  });

  return (
    <div className={cn(styles.root, styles[iconColor], className)}>
      {icon && iconPosition === 'left' && (
        <Icon type={icon} classname={iconClasses} />
      )}
      <span className={styles.text}>{text}</span>
      {icon && iconPosition === 'right' && (
        <Icon type={icon} classname={iconClasses} />
      )}
    </div>
  );
};
